import { ChatMessage, ChatbotVisualState } from '../../00_modules/ai-chatbot/models/ai-chatbot.model';

export class SetAiChatbotOpen {
    static readonly type = '[AI Chatbot] Set Open';

    constructor(public isOpen: boolean) {}
}

export class SetAiChatbotThreadId {
    static readonly type = '[AI Chatbot] Set ThreadId';

    constructor(public threadId: string | null) {}
}

export class SetAiChatbotVisualState {
    static readonly type = '[AI Chatbot] Set Visual State';

    constructor(public visualState: ChatbotVisualState) {}
}

export class SetAiChatbotOrderContext {
    static readonly type = '[AI Chatbot] Set Order Context';

    constructor(public orderId: number | null) {}
}

export class SetAiChatbotOrderContextConsent {
    static readonly type = '[AI Chatbot] Set Order Context Consent';

    constructor(public consent: boolean | null) {}
}

export class SetAiChatbotOrderContextPrompted {
    static readonly type = '[AI Chatbot] Set Order Context Prompted';

    constructor(public orderId: number | null) {}
}

export class AppendAiChatbotMessage {
    static readonly type = '[AI Chatbot] Append Message';

    constructor(public message: ChatMessage) {}
}

export class ResetAiChatbotState {
    static readonly type = '[AI Chatbot] Reset State';
}
